import React from 'react';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';

import ShareIcon from '@material-ui/icons/Share';

import tools from '../../../components/util/tools';

export default function TitleSection(props) {
  const { ctx, res, classes, statusOptions } = props;
  const readOnly = !ctx.state.editForm;
  const isOriginCompany = ctx.state.companyID === ctx.state.companyOriginID;

  const selectedStatusOption = statusOptions.find((i) => i.value === (ctx.state.status || '')) || null;
  const selectedTip = (selectedStatusOption && selectedStatusOption.tip) ? selectedStatusOption.tip : '';

  const blockAndAlert = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof ctx.alertReadOnly === 'function') ctx.alertReadOnly();
  };

  const Shield = readOnly ? (
    <div
      style={{ position: 'absolute', inset: 0, zIndex: 2 }}
      tabIndex={-1}
      aria-hidden="true"
      onMouseDown={blockAndAlert}
    />
  ) : null;

  return (
    <div className="form-group" style={{ textAlign: 'left' }}>
      {(ctx.state.share_status === 'compartilhado' ||
        ctx.state.share_status === 'retornado') && (
          <Chip
            style={{ marginBottom: '1rem' }}
            label={
              isOriginCompany
                ? tools.replaceString(
                  res._TRABALHO_COMPARTILHADO_COM,
                  ctx.state.companySharedName
                )
                : tools.replaceString(
                  res._TRABALHO_COMPARTILHADO_POR,
                  ctx.state.companyOriginName
                )
            }
            variant="outlined"
            icon={<ShareIcon />}
          />
        )}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <TextField
          id="title"
          label={res.TITULO}
          value={ctx.state.title}
          onChange={ctx.handleChange('title')}
          margin="normal"
          fullWidth
          onInput={(e) => {
            e.target.value = e.target.value.toString().slice(0, 45);
          }}
          style={{ width: '40rem' }}
          InputProps={{ readOnly }}
          onMouseDown={readOnly ? blockAndAlert : undefined}
        />

        <TextField
          id="serviceOrder"
          label={res.NUMERO_OS}
          value={ctx.state.serviceOrder || ''}
          margin="normal"
          fullWidth
          style={{ width: '12rem' }}
          InputProps={{ readOnly: true }}
        />

        <div style={{ position: 'relative', marginTop: '1rem', width: '12rem' }}>
          {Shield}
          <FormControl style={{ width: '100%' }}>
            <InputLabel id="status-label">{res.STATUS}</InputLabel>
            <Tooltip
              title={ctx.state.status ? selectedTip : ''}
              arrow
              placement="top"
              disableHoverListener={!ctx.state.status}
              classes={{ tooltip: classes.tipBig, arrow: classes.arrow }}
            >
              <Select
                key={res.LINGUA}
                id="status"
                labelId="status-label"
                className={classes.selectHelp}
                value={ctx.state.status || ''}
                onChange={ctx.handleChange('status')}
                inputProps={{ tabIndex: readOnly ? -1 : 0, 'aria-readonly': readOnly }}
                MenuProps={{
                  anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                  transformOrigin: { vertical: 'top', horizontal: 'left' },
                  getContentAnchorEl: null
                }}
                displayEmpty
                renderValue={(v) => {
                  if (!v) return res.SELECIONE;
                  const opt = statusOptions.find((i) => i.value === v);
                  return opt ? opt.label : v;
                }}
              >
                {statusOptions.map((it) => (
                  <MenuItem key={it.value} value={it.value}>
                    <Tooltip
                      title={it.tip}
                      arrow
                      placement="right"
                      enterDelay={200}
                      enterTouchDelay={0}
                      classes={{ tooltip: classes.tip, arrow: classes.arrow }}
                    >
                      <span style={{ display: 'inline-block', width: '100%' }}>
                        {it.label}
                      </span>
                    </Tooltip>
                  </MenuItem>
                ))}
              </Select>
            </Tooltip>
          </FormControl>
        </div>
      </div>
    </div>
  );
}